// extracted by mini-css-extract-plugin
export default {"TeamsListItem":"TeamsListItem_TeamsListItem__Cwc2t","TeamsListItem__action":"TeamsListItem_TeamsListItem__action__beC05"};